module.exports = __webpack_public_path__ + "static/media/download.100fe93e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/download.png
// module id = 992
// module chunks = 1